import { withI18n } from 'react-i18next';
import ConfirmationCard from './ConfirmationCard';
import {
  cartActions,
  cartisDownloadingPdfSel,
  cartErrorSel
} from 'src/store/modules/cart';
import { connect } from 'react-redux';

export const pureComponent = ConfirmationCard;
const mapStateToProps = (state: any) => {
  return {
    isDownloadingPdf: cartisDownloadingPdfSel(state),
    downloadError: cartErrorSel(state)
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  downloadPdf: (orderData: string) => {
    dispatch(cartActions.downloadOrderPdf(orderData));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(ConfirmationCard));
